import { lazy } from 'react'

export const Accomplish = lazy(() => import('./Accomplish'))
